// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4c47bfc7","969":"6a1dbf1f"}[chunkId] + ".chunk.js";
};